(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2636],{

/***/ 76926:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Lx": () => (/* reexport */ EventNameEnum),
  "ZP": () => (/* binding */ esm)
});

// UNUSED EXPORTS: EnvEnum, SaasSubscription, ThemeEnum, openVipComparePopup

;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/types/enum.js
/**
 * 环境变量枚举
 */
var EnvEnum = /*#__PURE__*/function (EnvEnum) {
  EnvEnum["LOCAL"] = "local";
  EnvEnum["PRE"] = "pre";
  EnvEnum["BETA"] = "beta";
  EnvEnum["RELEASE"] = "release";
  return EnvEnum;
}({});
/**
 * 主题色
 */
var ThemeEnum = /*#__PURE__*/function (ThemeEnum) {
  ThemeEnum["DARK"] = "dark";
  ThemeEnum["LIGHT"] = "light";
  return ThemeEnum;
}({});
/**
 * 事件名称枚举
 */
var EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["SUCCESS"] = "success";
  EventNameEnum["FAIL"] = "fail";
  EventNameEnum["LOGININVALID"] = "login-invalid";
  EventNameEnum["CLOSE"] = "close";
  return EventNameEnum;
}({});
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/constants/index.js
/**
 * 订阅弹窗样式
 */
var dialogCss = "\n  .saas-subscription-popup {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 9999;\n  }\n\n  .saas-subscription-popup__inner {\n    width: 931px;\n    height: 588px;\n    border-radius: 12px;\n    background-color: #fff;\n    position: relative;\n  }\n\n  .saas-subscription-popup.dark .saas-subscription-popup__inner {\n    background-color: #1C1D1F;\n  }\n\n  .saas-subscription-popup__inner iframe {\n    border-radius: 12px;\n  }\n\n  .saas-subscription-popup__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    transition: all 0.5s ease;\n  }\n\n  .saas-subscription-popup__close:hover {\n    transform: rotate(180deg);\n  }\n\n  @media screen and (max-height: 620px) {\n    .saas-subscription-popup {\n      display: block;\n      overflow: auto;\n      /* \u706B\u72D0\u7279\u5B9A\u6EDA\u52A8\u6761\u6837\u5F0F */\n      scrollbar-width: none;\n    }\n\n    .saas-subscription-popup::-webkit-scrollbar {\n      display: none;\n    }\n\n    .saas-subscription-popup__inner {\n      margin: 30px auto 0;\n    }\n  }\n";

/**
 * 权益对比弹窗样式
 */
var popupCss = "\n  .vip-compare-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-compare-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-compare-modal__inner {\n    width: 630px;\n    max-width: 100vw;\n    height: 565px;\n    max-height: 100vh;\n    padding: 16px 16px 20px;\n    border-radius: 12px;\n    background: var(--background-system-frame-floatpanel, #FFF);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 24px 128px 0px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vip-compare-modal__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .vip-compare-modal__title {\n    color: var(--content-system-primary, #1C1D1F);\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n  }\n\n  .vip-compare-modal__close {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    transition: all 0.5s ease;\n  }\n\n  .vip-compare-modal__close:hover {\n    transform: rotate(180deg);\n  }\n\n  .vip-compare-modal__body {\n    flex: 1;\n    margin-top: 16px;\n    padding-right: 2px;\n    overflow-y: auto;\n  }\n\n  .vip-compare-modal__body-inner {\n    color: var(--content-web-primary, #17181A);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    border-radius: 4px;\n    border: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n    position: relative;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar {\n    display: block;\n    -webkit-appearance: none;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar:vertical {\n    width: 4px;\n  }\n\n  .vip-compare-modal__body::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 4px solid rgba(0, 0, 0, 0.2);\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n\n  .vip-compare-modal__body-header {\n    position: sticky;\n    top: 0;\n    background: var(--background-system-frame-floatpanel, #FFF);\n  }\n\n  .vip-compare-modal__thead {\n    height: 40px;\n    background: var(--background-system-selected, #E5F2FF);\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__trow {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--stroke-system-border-overlay, rgba(0, 0, 0, 0.08));\n  }\n\n  .vip-compare-modal__cell {\n    width: 145px;\n    padding: 10px;\n    text-align: center;\n  }\n\n  .vip-compare-modal__cell:nth-child(1) {\n    width: auto;\n    flex: 1;\n    text-align: left;\n  }\n\n  .vip-compare-modal__tbody .vip-compare-modal__trow:last-child {\n    border-bottom: none;\n  }\n\n  .vip-compare-modal__trow-title {\n    background: var(--background-web-secondary, rgba(0, 30, 89, 0.04));\n  }\n";

/**
 * 阻断弹窗样式
 */
var retentionCss = "\n  .vip-retention-modal {\n    background-color: var(--background-system-overlay-mask, rgba(0, 0, 0, 0.5));\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000000001;\n  }\n\n  .vip-retention-modal * {\n    box-sizing: border-box;\n  }\n\n  .vip-retention-modal__inner {\n    width: 300px;\n    height: 400px;\n    max-width: 100vw;\n    max-height: 100vh;\n    position: relative;\n  }\n\n  .vip-retention-modal__inner img {\n    width: 100%;\n  }\n\n  .vip-retention-modal__close {\n    width: 25px;\n    height: 25px;\n    cursor: pointer;\n    position: absolute;\n    right: 22px;\n    top: 22px;\n  }\n\n  .vip-retention-modal__btn {\n    width: 170px;\n    height: 45px;\n    cursor: pointer;\n    position: absolute;\n    left: 50%;\n    bottom: 33px;\n    transform: translateX(-50%);\n  }\n";

// 弹窗阻断次数缓存
var SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER = "saas-subscription-popup-retention-number";
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/utils/index.js

/**
 * 版本权益对比弹窗
 */
var openVipComparePopup = function openVipComparePopup() {
  var dataSource = {
    内容服务: [["免费模版/PPT", true, true, true], ["免费字体", true, true, true], ["免费素材", true, true, true], ["付费模版/PPT", false, true, true], ["付费字体", false, true, true], ["付费素材", false, true, true], ["商用授权", false, "个人商用", "企业商用(1个主体)"]],
    创作工具: [["拼图", true, true, true], ["AI消除", false, true, true], ["AI尺寸延展", "限时免费", true, true], ["服装去皱", false, true, true], ["无损放大", false, true, true], ["变清晰", false, true, true]],
    多人协同: [["文件共享", true, true, true], ["文件夹共享", false, false, true], ["共享权限管理", false, false, true], ["品牌规范", false, false, true], ["模版库(PSD上传)", false, false, true]],
    团队管理: [["角色管理", false, false, true], ["数据看板", false, false, true], ["订单管理", false, false, true]],
    消耗品: [["智能抠图", false, "1200张/年", "100张*席位数/月"], ["会员美豆", false, "120个/月", "120个*席位数/月"]]
  };
  console.log(Object.keys(dataSource));
  var ele = document.createElement("div");
  ele.className = "vip-compare-modal";
  var strDom = "\n      <div class=\"vip-compare-modal__inner\">\n          <div class=\"vip-compare-modal__header\">\n              <span class=\"vip-compare-modal__title\">\u7248\u672C\u6743\u76CA\u8BF4\u660E</span>\n              <img class=\"vip-compare-modal__close\" src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png\" alt=\"\">\n          </div>\n          <div class=\"vip-compare-modal__body\">\n            <div class=\"vip-compare-modal__body-inner\">\n              <div class=\"vip-compare-modal__body-header\">\n                  <div class=\"vip-compare-modal__thead\">\n                      <div class=\"vip-compare-modal__cell\">\u7248\u672C</div>\n                      <div class=\"vip-compare-modal__cell\">\u514D\u8D39\u7248</div>\n                      <div class=\"vip-compare-modal__cell\">\u4E2A\u4EBA\u7248SVIP</div>\n                      <div class=\"vip-compare-modal__cell\">\u56E2\u961F\u7248VIP</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u4EF7\u683C</div>\n                      <div class=\"vip-compare-modal__cell\">\xA50/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5288/\u5E74</div>\n                      <div class=\"vip-compare-modal__cell\">\xA5318/\u5E2D\u4F4D/\u5E74</div>\n                  </div>\n                  <div class=\"vip-compare-modal__trow\">\n                      <div class=\"vip-compare-modal__cell\">\u9002\u7528\u4EBA\u6570</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">1\u4EBA</div>\n                      <div class=\"vip-compare-modal__cell\">\u591A\u4EBA</div>\n                  </div>\n              </div>\n              <div class=\"vip-compare-modal__tbody\">\n                  ";
  Object.keys(dataSource).forEach(function (key) {
    strDom += "\n          <div class=\"vip-compare-modal__trow\">\n              <div class=\"vip-compare-modal__cell vip-compare-modal__trow-title\">".concat(key, "</div>\n          </div>\n      ");
    dataSource[key].forEach(function (item) {
      strDom += "\n              <div class=\"vip-compare-modal__trow\">\n                  ";
      item.forEach(function (data) {
        if (typeof data === "string") {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">".concat(data, "</div>\n                  ");
        } else if (!!data) {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\">\n                          <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                              <path d=\"M11.4018 2.21587C11.6968 2.50668 11.7001 2.98154 11.4093 3.2765L5.12216 9.6515C4.97783 9.79789 4.77975 9.87861 4.57421 9.87481C4.36868 9.87101 4.17372 9.78301 4.03491 9.63139L0.572068 5.86055C0.292363 5.55504 0.313286 5.08063 0.6188 4.80092C0.924313 4.52122 1.39873 4.54214 1.67843 4.84766L4.60823 8.03626L10.3412 2.22338C10.632 1.92842 11.1069 1.92506 11.4018 2.21587Z\" fill=\"#3388FF\"/>\n                          </svg>    \n                      </div>\n                  ";
        } else {
          strDom += "\n                      <div class=\"vip-compare-modal__cell\"></div>\n                  ";
        }
      });
      strDom += "\n              </div>\n          ";
    });
  });
  strDom += "\n              </div>\n          </div>\n        </div>\n      </div>\n    ";
  ele.innerHTML = strDom;
  document.body.appendChild(ele);

  // 创建样式
  var eleStyle = document.createElement("style");
  eleStyle.innerHTML = popupCss;
  document.head.appendChild(eleStyle);
  var eleClose = document.querySelector(".vip-compare-modal__close");
  if (eleClose) {
    eleClose.onclick = function () {
      document.body.removeChild(ele);
      document.head.removeChild(eleStyle);
    };
  }
};
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/lib/index.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



var SaasSubscription = /*#__PURE__*/function () {
  function SaasSubscription(_params) {
    var _this = this;
    _classCallCheck(this, SaasSubscription);
    _defineProperty(this, "env", void 0);
    _defineProperty(this, "theme", void 0);
    _defineProperty(this, "commonParams", void 0);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "shouldRetention", false);
    _defineProperty(this, "onTrack", void 0);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "ele", null);
    /**
     * 弹窗元素
     */
    _defineProperty(this, "eleIframe", null);
    /**
     * 权益对比弹窗元素
     */
    _defineProperty(this, "elePopup", null);
    /**
     * 关闭按钮元素
     */
    _defineProperty(this, "eleClose", null);
    _defineProperty(this, "messageHandler", function (e) {
      var data = e.data || e.originalEvent && e.originalEvent.data;
      if (typeof data === "string" && /^[\[\{]/.test(data)) {
        data = JSON.parse(data);
      }

      // 关闭订阅弹窗通知
      if (data && data.action === "closeVipSubscribeDialog") {
        // 未登录
        if (data.data && data.data.needLogin) {
          var handler = _this.eventHandlers[EventNameEnum.LOGININVALID];
          if (handler) {
            handler();
          }
          _this.close(false);
        }

        // 支付成功
        if (data.data && data.data.success) {
          var _handler = _this.eventHandlers[EventNameEnum.SUCCESS];
          if (_handler) {
            _handler();
          }
          _this.close(false);
        }
      } else if (data && data.action === "changeCloseVipSubscribeDialogCloseIcon") {
        // 显示/隐藏弹窗关闭按钮
        if (data.data) {
          if (_this.eleClose) {
            var _data$data;
            _this.eleClose.style.visibility = (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.status ? "visible" : "hidden";
          }
        }
      } else if (data && data.action === "openVipComparePopup") {
        // 打开版本权益说明弹窗
        openVipComparePopup();
      }
    });
    /**
     * 获取最新的订阅访问URL
     * @param customParams 自定义参数
     * @returns
     */
    _defineProperty(this, "getLatestUrl", function (customParams) {
      var params = Object.assign({}, _this.commonParams, customParams);
      var queryString = Object.keys(params).reduce(function (str, key) {
        return str + "".concat(key, "=").concat(params[key] || "", "&");
      }, "");
      var preHost = "";
      if (/\.meitu\.com/.test(window.location.host) || /localhost/.test(window.location.host)) {
        // .meitu.com 域名，都统一走pc.meitu.com域名
        switch (_this.env) {
          case EnvEnum.PRE:
          case EnvEnum.LOCAL:
            preHost = "https://prepc.meitu.com";
            break;
          case EnvEnum.BETA:
            preHost = "https://beta-pc.meitu.com";
            break;
          case EnvEnum.RELEASE:
            preHost = "https://pc.meitu.com";
            break;
          default:
        }
      } else {
        // 非.meitu.com 域名，都统一走当前域名
        preHost = "".concat(window.location.protocol, "//").concat(window.location.host);
      }

      // 本地开发
      if (_this.env === EnvEnum.LOCAL) {
        preHost = "https://prepc.meitu.com";
      }
      return "".concat(preHost, "/vip?theme=").concat(_this.theme, "&").concat(queryString);
    });
    /**
     * 创建弹窗容器
     */
    _defineProperty(this, "createDialog", function () {
      // 创建容器
      var eleDialog = document.createElement("div");
      eleDialog.className = "saas-subscription-popup ".concat(_this.theme);
      var eleInner = document.createElement("div");
      eleInner.className = "saas-subscription-popup__inner";

      // 创建关闭安按钮
      var eleClose = document.createElement("img");
      eleClose.className = "saas-subscription-popup__close";
      eleClose.src = "https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/close-icon.png";
      eleClose.onclick = function () {
        var _window, _window$mtstat;
        // 重置为业务的uid
        // window.mtstat埋点login的uid值
        // 解决个人版打开团队版订阅弹窗场景，导致埋点的uid不对问题
        var uid = window.localStorage.getItem('uid');
        if (uid) (_window = window) === null || _window === void 0 ? void 0 : (_window$mtstat = _window.mtstat) === null || _window$mtstat === void 0 ? void 0 : _window$mtstat.login(uid);
        _this.close();
      };

      // 创建iframe
      var iframe = document.createElement("iframe");
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.src = _this.getLatestUrl({});
      eleInner.appendChild(iframe);
      eleInner.appendChild(eleClose);
      eleDialog.appendChild(eleInner);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = dialogCss;
      document.head.appendChild(eleStyle);
      _this.ele = eleDialog;
      _this.eleClose = eleClose;
      _this.eleIframe = iframe;
    });
    /**
     *
     * 阻断弹窗
     */
    _defineProperty(this, "createRetentionDialog", function () {
      var _this$onTrack3;
      var ele = document.createElement("div");
      ele.className = "vip-retention-modal";
      var strDom = "\n        <div class=\"vip-retention-modal__inner\">\n            <img src=\"https://public.static.meitudata.com/xiuxiu-pc/saas-subscription/retention-bg.png\" alt=\"\">\n            <div class=\"vip-retention-modal__close\"></div>\n            <div class=\"vip-retention-modal__btn\"></div>    \n        </div>\n        ";
      ele.innerHTML = strDom;
      document.body.appendChild(ele);

      // 创建样式
      var eleStyle = document.createElement("style");
      eleStyle.innerHTML = retentionCss;
      document.head.appendChild(eleStyle);
      var eleClose = document.querySelector(".vip-retention-modal__close");
      var eleBtn = document.querySelector(".vip-retention-modal__btn");
      if (eleClose) {
        eleClose.onclick = function () {
          var _this$onTrack;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 关闭订阅弹窗
          _this.close(false);
          (_this$onTrack = _this.onTrack) === null || _this$onTrack === void 0 ? void 0 : _this$onTrack.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "close"
          });
        };
      }
      if (eleBtn) {
        eleBtn.onclick = function () {
          var _this$eleIframe, _this$eleIframe$conte, _this$onTrack2;
          // 重置阻拦状态
          _this.shouldRetention = false;
          // 关闭阻断弹窗
          document.body.removeChild(ele);
          // 通知订阅弹窗展示会员购买场景
          (_this$eleIframe = _this.eleIframe) === null || _this$eleIframe === void 0 ? void 0 : (_this$eleIframe$conte = _this$eleIframe.contentWindow) === null || _this$eleIframe$conte === void 0 ? void 0 : _this$eleIframe$conte.postMessage(JSON.stringify({
            action: "viewSubscription" // 查看购买会员商品组
          }), _this.getLatestUrl({}).replace(/\/vip?.+/, ""));
          (_this$onTrack2 = _this.onTrack) === null || _this$onTrack2 === void 0 ? void 0 : _this$onTrack2.call(_this, "operations_popup_click", {
            func: "retention_popup",
            class: "to_see"
          });
        };
      }
      (_this$onTrack3 = _this.onTrack) === null || _this$onTrack3 === void 0 ? void 0 : _this$onTrack3.call(_this, "operations_popup_show", {
        func: "retention_popup"
      });
    });
    this.env = _params.env || "release";
    this.theme = _params.theme || "light";
    this.commonParams = _params.commonParams || {};
  }

  /**
   * 监听事件
   *
   * @param eventName 事件名
   * @param handler 回调函数
   * @returns
   */
  _createClass(SaasSubscription, [{
    key: "on",
    value: function on(eventName, handler) {
      this.eventHandlers[eventName] = handler;
      return this;
    }

    /**
     * 打开弹窗
     * @param customParams 自定义参数
     * @returns
     */
  }, {
    key: "open",
    value: function open(customParams, otherParams) {
      this.shouldRetention = !!(otherParams !== null && otherParams !== void 0 && otherParams.shouldRetention);
      this.onTrack = otherParams === null || otherParams === void 0 ? void 0 : otherParams.onTrack;
      console.log(otherParams, "otherParams=========");
      if (!this.ele) {
        this.createDialog();
      }
      if (this.eleIframe) {
        this.eleIframe.src = this.getLatestUrl(customParams);
      }
      if (this.ele) {
        document.body.appendChild(this.ele);
      }
      window.addEventListener("message", this.messageHandler, false);
      return this;
    }

    /**
     * 关闭弹窗
     * @returns
     */
  }, {
    key: "close",
    value: function close() {
      var shouldCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var curDate = "".concat(new Date().getFullYear(), "-").concat(new Date().getMonth() + 1, "-").concat(new Date().getDate());
      var local = JSON.parse(window.localStorage.getItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER) || "{}");
      var localNum = local.date === curDate ? +(local.value || "0") : 0;
      if (shouldCheck && this.shouldRetention && localNum < 3) {
        window.localStorage.setItem(SAAS_SUBSCRIPTION_POPUP_RETENTION_NUMBER, JSON.stringify({
          date: curDate,
          value: localNum + 1
        }));
        this.createRetentionDialog();
        return;
      }
      var handler = this.eventHandlers[EventNameEnum.CLOSE];
      if (handler) {
        handler();
      }
      if (this.ele) {
        document.body.removeChild(this.ele);
      }
      if (typeof window.removeEventListener !== "undefined") {
        window.removeEventListener("message", this.messageHandler, false);
      }
      return this;
    }

    /**
     * 动态设置更新公共参数
     * @param params
     * @returns
     */
  }, {
    key: "setCommonParams",
    value: function setCommonParams(params) {
      if (params) {
        this.commonParams = Object.assign({}, this.commonParams, params);
      }
    }

    /**
     * 动态设置更新主题色
     * @param val
     * @returns
     */
  }, {
    key: "setTheme",
    value: function setTheme(val) {
      if (val) {
        this.theme = val;
        if (this.ele) this.ele.className = "saas-subscription-popup ".concat(this.theme);
      }
    }
  }]);
  return SaasSubscription;
}();
/* harmony default export */ const lib = (SaasSubscription);
;// CONCATENATED MODULE: ./node_modules/@meitu/saas-subscription-popup/dist/esm/index.js





/* harmony default export */ const esm = (lib);

/***/ }),

/***/ 36525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_IconFont)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/config.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var config = {
    isIntl: false
};
var getConfig = function getConfig() {
    return _objectSpread({}, config);
};
var setConfig = function setConfig(params) {
    for(var key in params){
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            var typedKey = key;
            config[typedKey] = params[typedKey];
        }
    }
};

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/iconHash.js
// ⚠️ 此文件由 scripts/gen-icon-hash.ts 自动生成，请勿手动修改
var ICON_HASH = "15ed2b36";

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/IconFont.js
/* provided dependency */ var process = __webpack_require__(34155);
function IconFont_typeof(obj) {
    "@babel/helpers - typeof";
    return IconFont_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, IconFont_typeof(obj);
}
var _excluded = [
    "name",
    "className",
    "color",
    "fontSize",
    "style",
    "onClick"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function IconFont_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function IconFont_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? IconFont_ownKeys(Object(source), !0).forEach(function(key) {
            IconFont_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IconFont_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function IconFont_defineProperty(obj, key, value) {
    key = IconFont_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function IconFont_toPropertyKey(arg) {
    var key = IconFont_toPrimitive(arg, "string");
    return IconFont_typeof(key) === "symbol" ? key : String(key);
}
function IconFont_toPrimitive(input, hint) {
    if (IconFont_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (IconFont_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == IconFont_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var iconCache = new Map();
var pendingFetches = new Map();
/**
 * IIcontFont 是 IIconFontProps 的类型别名（为了兼容旧版本的定义）
 */ var IconFont = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var name = props.name, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, color = props.color, fontSize = props.fontSize, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, onClick = props.onClick, restProps = _objectWithoutProperties(props, _excluded);
    var _useState = (0,react.useState)(null), _useState2 = _slicedToArray(_useState, 2), svgContent = _useState2[0], setSvgContent = _useState2[1];
    var _useState3 = (0,react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), error = _useState4[0], setError = _useState4[1];
    var _getConfig = getConfig(), isIntl = _getConfig.isIntl;
    (0,react.useEffect)(function() {
        var _process$env;
        var isMounted = true;
        var isDev = typeof process !== "undefined" && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.UMI_APP_ENV) === "development"; // 兼容SSR环境
        var cdnPrefix = isIntl ? "https://x-design-static-release.stariicloud.com" : "https://pc.meitudata.com";
        var nameOriginal = name.charAt(0).toLowerCase() + name.slice(1);
        var url = isDev ? "/x-design-icons/icons/".concat(nameOriginal, ".svg") : "".concat(cdnPrefix, "/x-design-icons/").concat(ICON_HASH, "/").concat(nameOriginal, ".svg");
        var loadSVG = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                var content, fetchPromise, svg;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while(1)switch(_context2.prev = _context2.next){
                        case 0:
                            if (!iconCache.has(name)) {
                                _context2.next = 3;
                                break;
                            }
                            setSvgContent(iconCache.get(name));
                            return _context2.abrupt("return");
                        case 3:
                            if (!pendingFetches.has(name)) {
                                _context2.next = 9;
                                break;
                            }
                            _context2.next = 6;
                            return pendingFetches.get(name);
                        case 6:
                            content = _context2.sent;
                            if (isMounted) setSvgContent(content);
                            return _context2.abrupt("return");
                        case 9:
                            fetchPromise = fetch(url).then(/*#__PURE__*/ function() {
                                var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(res) {
                                    var svgText, parser, doc, svg;
                                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                                        while(1)switch(_context.prev = _context.next){
                                            case 0:
                                                if (res.ok) {
                                                    _context.next = 2;
                                                    break;
                                                }
                                                throw new Error("Failed to load ".concat(name));
                                            case 2:
                                                _context.next = 4;
                                                return res.text();
                                            case 4:
                                                svgText = _context.sent;
                                                // 用 DOMParser 解析 SVG 内容为 DOM
                                                parser = new DOMParser();
                                                doc = parser.parseFromString(svgText, "image/svg+xml");
                                                svg = doc.querySelector("svg");
                                                if (svg) {
                                                    _context.next = 10;
                                                    break;
                                                }
                                                throw new Error("Invalid SVG content for icon [".concat(name, "]"));
                                            case 10:
                                                // 设置 width/height 为 1em
                                                svg.setAttribute("width", "1em");
                                                svg.setAttribute("height", "1em");
                                                // 设置 fill="currentColor"（排除 fill="none"）
                                                svg.querySelectorAll("[fill]").forEach(function(el) {
                                                    var fill = el.getAttribute("fill");
                                                    if (fill && fill.toLowerCase() !== "none") {
                                                        el.setAttribute("fill", "currentColor");
                                                    }
                                                });
                                                // 移除 <defs> 节点
                                                svg.querySelectorAll("defs").forEach(function(defs) {
                                                    return defs.remove();
                                                });
                                                // 移除 clip-path、mask、filter 属性
                                                [
                                                    "clip-path",
                                                    "mask",
                                                    "filter"
                                                ].forEach(function(attr) {
                                                    svg.querySelectorAll("[".concat(attr, "]")).forEach(function(el) {
                                                        el.removeAttribute(attr);
                                                    });
                                                });
                                                return _context.abrupt("return", svg.outerHTML);
                                            case 16:
                                            case "end":
                                                return _context.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }()).then(function(svg) {
                                iconCache.set(name, svg);
                                return svg;
                            }).catch(function(err) {
                                ;
                                setError(true);
                                return "";
                            });
                            pendingFetches.set(name, fetchPromise);
                            _context2.next = 13;
                            return fetchPromise;
                        case 13:
                            svg = _context2.sent;
                            if (isMounted) setSvgContent(svg);
                        case 15:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function loadSVG() {
                return _ref.apply(this, arguments);
            };
        }();
        loadSVG();
        return function() {
            isMounted = false;
        };
    }, [
        name
    ]);
    var size = style.fontSize || fontSize || 12;
    return /*#__PURE__*/ react.createElement("span", _extends({
        className: "iconfont icon-".concat(name, " ").concat(className),
        "alias-name": name,
        style: IconFont_objectSpread({
            width: size,
            height: size,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: color,
            fontSize: size
        }, style),
        dangerouslySetInnerHTML: svgContent && !error ? {
            __html: svgContent
        } : undefined,
        ref: ref
    }, restProps, {
        onClick: onClick
    }));
});
/* harmony default export */ const dist_IconFont = (/*#__PURE__*/react.memo(IconFont));


/***/ }),

/***/ 79636:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _style_default_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50578);
/* harmony import */ var _style_default_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_default_css__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24382);
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),

/***/ 24382:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 50578:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 4298:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports =
   false
    ? 0
    : __webpack_require__(63573)


/***/ }),

/***/ 15105:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */

var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey ||
    // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }

    // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }

    // Safari sends zero key code for non-latin characters.
    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (KeyCode);

/***/ }),

/***/ 59015:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _Dom_canUseDom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98924);



var Portal = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
  var didUpdate = props.didUpdate,
    getContainer = props.getContainer,
    children = props.children;
  var parentRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  // Ref return nothing, only for wrapper check exist
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {};
  });

  // Create container in client side with sync to avoid useEffect not get ref
  var initRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  if (!initRef.current && (0,_Dom_canUseDom__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) {
    containerRef.current = getContainer();
    parentRef.current = containerRef.current.parentNode;
    initRef.current = true;
  }

  // [Legacy] Used by `rc-trigger`
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    didUpdate === null || didUpdate === void 0 || didUpdate(props);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Restore container to original place
    // React 18 StrictMode will unmount first and mount back for effect test:
    // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
    if (containerRef.current.parentNode === null && parentRef.current !== null) {
      parentRef.current.appendChild(containerRef.current);
    }
    return function () {
      var _containerRef$current;
      // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
      // Since some component use `Portal` directly, we have to keep the logic here.
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, containerRef.current) : null;
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Portal);

/***/ }),

/***/ 74204:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ getScrollBarSize),
/* harmony export */   "o": () => (/* binding */ getTargetScrollBarSize)
/* harmony export */ });
/* harmony import */ var _Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44958);
/* eslint-disable no-param-reassign */

var cached;
function measureScrollbarSize(ele) {
  var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
  var measureEle = document.createElement('div');
  measureEle.id = randomId;

  // Create Style
  var measureStyle = measureEle.style;
  measureStyle.position = 'absolute';
  measureStyle.left = '0';
  measureStyle.top = '0';
  measureStyle.width = '100px';
  measureStyle.height = '100px';
  measureStyle.overflow = 'scroll';

  // Clone Style if needed
  var fallbackWidth;
  var fallbackHeight;
  if (ele) {
    var targetStyle = getComputedStyle(ele);
    measureStyle.scrollbarColor = targetStyle.scrollbarColor;
    measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;

    // Set Webkit style
    var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
    var width = parseInt(webkitScrollbarStyle.width, 10);
    var height = parseInt(webkitScrollbarStyle.height, 10);

    // Try wrap to handle CSP case
    try {
      var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
      var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
      (0,_Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__/* .updateCSS */ .hq)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
    } catch (e) {
      // Can't wrap, just log error
      console.error(e);

      // Get from style directly
      fallbackWidth = width;
      fallbackHeight = height;
    }
  }
  document.body.appendChild(measureEle);

  // Measure. Get fallback style if provided
  var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
  var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;

  // Clean up
  document.body.removeChild(measureEle);
  (0,_Dom_dynamicCSS__WEBPACK_IMPORTED_MODULE_0__/* .removeCSS */ .jL)(randomId);
  return {
    width: scrollWidth,
    height: scrollHeight
  };
}
function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }
  if (fresh || cached === undefined) {
    cached = measureScrollbarSize();
  }
  return cached.width;
}
function getTargetScrollBarSize(target) {
  if (typeof document === 'undefined' || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  return measureScrollbarSize(target);
}

/***/ }),

/***/ 7028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export resetUuid */
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function getUseId() {
  // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
  var fullClone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2))));
  return fullClone.useId;
}
var uuid = 0;

/** @private Note only worked in develop env. Not work in production. */
function resetUuid() {
  if (false) {}
}
var useOriginId = getUseId();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOriginId ?
// Use React `useId`
function useId(id) {
  var reactId = useOriginId();

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (false) {}
  return reactId;
} :
// Use compatible of `useId`
function useCompatId(id) {
  // Inner id for accessibility usage. Only work in client side
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState('ssr-id'),
    _React$useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_React$useState, 2),
    innerId = _React$useState2[0],
    setInnerId = _React$useState2[1];
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var nextId = uuid;
    uuid += 1;
    setInnerId("rc_unique_".concat(nextId));
  }, []);

  // Developer passed id is single source of truth
  if (id) {
    return id;
  }

  // Test env always return mock id
  if (false) {}

  // Return react native id or inner id
  return innerId;
});

/***/ }),

/***/ 64217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ pickAttrs)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);

var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);

/* eslint-enable max-len */
var ariaPrefix = 'aria-';
var dataPrefix = 'data-';
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
/**
 * Picker props from exist props with filter
 * @param props Passed props
 * @param ariaOnly boolean | { aria?: boolean; data?: boolean; attr?: boolean; } filter config
 */
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function (key) {
    if (
    // Aria
    mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) ||
    // Data
    mergedConfig.data && match(key, dataPrefix) ||
    // Attr
    mergedConfig.attr && propList.includes(key)) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

/***/ }),

/***/ 14000:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K5": () => (/* binding */ getMTCCClient)
});

// UNUSED EXPORTS: gaEventTracker, getCountryCode, getDemo, performanceMonitor, popupManager

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({ randomUUID });

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/rng.js
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
            throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        }
        getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return getRandomValues(rnds8);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/stringify.js

const byteToHex = [];
for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset);
    if (!validate(uuid)) {
        throw TypeError('Stringified UUID is invalid');
    }
    return uuid;
}
/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
    if (esm_browser_native.randomUUID && !buf && !options) {
        return esm_browser_native.randomUUID();
    }
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? rng();
    if (rnds.length < 16) {
        throw new Error('Random bytes length must be >= 16');
    }
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) {
            throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        }
        for (let i = 0; i < 16; ++i) {
            buf[offset + i] = rnds[i];
        }
        return buf;
    }
    return unsafeStringify(rnds);
}
/* harmony default export */ const esm_browser_v4 = (v4);

;// CONCATENATED MODULE: ./node_modules/web-vitals/dist/web-vitals.js
var e,n,t,r,i,o=-1,a=function(e){addEventListener("pageshow",(function(n){n.persisted&&(o=n.timeStamp,e(n))}),!0)},c=function(){var e=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(e&&e.responseStart>0&&e.responseStart<performance.now())return e},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),r="navigate";o>=0?r="back-forward-cache":t&&(document.prerendering||u()>0?r="prerender":document.wasDiscarded?r="restore":t.type&&(r=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:r}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var r=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return r.observe(Object.assign({type:e,buffered:!0},t||{})),r}}catch(e){}},d=function(e,n,t,r){var i,o;return function(a){n.value>=0&&(a||r)&&((o=n.value-(i||0))||void 0===i)&&(i=n.value,n.delta=o,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&e()}))},v=function(e){var n=!1;return function(){n||(e(),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),a((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},b=[1800,3e3],S=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("FCP"),o=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(o.disconnect(),e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries.push(e),t(!0)))}))}));o&&(t=d(e,i,b,n.reportAllChanges),a((function(r){i=f("FCP"),t=d(e,i,b,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,t(!0)}))})))}))},L=[.1,.25],w=function(e,n){n=n||{},S(v((function(){var t,r=f("CLS",0),i=0,o=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=o[0],t=o[o.length-1];i&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(i+=e.value,o.push(e)):(i=e.value,o=[e])}})),i>r.value&&(r.value=i,r.entries=o,t())},u=s("layout-shift",c);u&&(t=d(e,r,L,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),a((function(){i=0,r=f("CLS",0),t=d(e,r,L,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A=0,I=1/0,P=0,M=function(e){e.forEach((function(e){e.interactionId&&(I=Math.min(I,e.interactionId),P=Math.max(P,e.interactionId),A=P?(P-I)/7+1:0)}))},k=function(){return e?A:performance.interactionCount||0},F=function(){"interactionCount"in performance||e||(e=s("event",M,{type:"event",buffered:!0,durationThreshold:0}))},D=[],x=new Map,R=0,B=function(){var e=Math.min(D.length-1,Math.floor((k()-R)/50));return D[e]},H=[],q=function(e){if(H.forEach((function(n){return n(e)})),e.interactionId||"first-input"===e.entryType){var n=D[D.length-1],t=x.get(e.interactionId);if(t||D.length<10||e.duration>n.latency){if(t)e.duration>t.latency?(t.entries=[e],t.latency=e.duration):e.duration===t.latency&&e.startTime===t.entries[0].startTime&&t.entries.push(e);else{var r={id:e.interactionId,latency:e.duration,entries:[e]};x.set(r.id,r),D.push(r)}D.sort((function(e,n){return n.latency-e.latency})),D.length>10&&D.splice(10).forEach((function(e){return x.delete(e.id)}))}}},O=function(e){var n=self.requestIdleCallback||self.setTimeout,t=-1;return e=v(e),"hidden"===document.visibilityState?e():(t=n(e),p(e)),t},N=[200,500],j=function(e,n){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(n=n||{},C((function(){var t;F();var r,i=f("INP"),o=function(e){O((function(){e.forEach(q);var n=B();n&&n.latency!==i.value&&(i.value=n.latency,i.entries=n.entries,r())}))},c=s("event",o,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});r=d(e,i,N,n.reportAllChanges),c&&(c.observe({type:"first-input",buffered:!0}),p((function(){o(c.takeRecords()),r(!0)})),a((function(){R=k(),D.length=0,x.clear(),i=f("INP"),r=d(e,i,N,n.reportAllChanges)})))})))},_=[2500,4e3],z={},G=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("LCP"),o=function(e){n.reportAllChanges||(e=e.slice(-1)),e.forEach((function(e){e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries=[e],t())}))},c=s("largest-contentful-paint",o);if(c){t=d(e,i,_,n.reportAllChanges);var m=v((function(){z[i.id]||(o(c.takeRecords()),c.disconnect(),z[i.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return O(m)}),{once:!0,capture:!0})})),p(m),a((function(r){i=f("LCP"),t=d(e,i,_,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,z[i.id]=!0,t(!0)}))}))}}))},J=[800,1800],K=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Q=function(e,n){n=n||{};var t=f("TTFB"),r=d(e,t,J,n.reportAllChanges);K((function(){var i=c();i&&(t.value=Math.max(i.responseStart-u(),0),t.entries=[i],r(!0),a((function(){t=f("TTFB",0),(r=d(e,t,J,n.reportAllChanges))(!0)})))}))},U={passive:!0,capture:!0},V=new Date,W=function(e,i){n||(n=i,t=e,r=new Date,Z(removeEventListener),X())},X=function(){if(t>=0&&t<r-V){var e={entryType:"first-input",name:n.type,target:n.target,cancelable:n.cancelable,startTime:n.timeStamp,processingStart:n.timeStamp+t};i.forEach((function(n){n(e)})),i=[]}},Y=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){W(e,n),i()},r=function(){i()},i=function(){removeEventListener("pointerup",t,U),removeEventListener("pointercancel",r,U)};addEventListener("pointerup",t,U),addEventListener("pointercancel",r,U)}(n,e):W(n,e)}},Z=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,Y,U)}))},$=(/* unused pure expression or super */ null && ([100,300])),ee=function(e,r){r=r||{},C((function(){var o,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),o(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);o=d(e,u,$,r.reportAllChanges),h&&(p(v((function(){m(h.takeRecords()),h.disconnect()}))),a((function(){var a;u=f("FID"),o=d(e,u,$,r.reportAllChanges),i=[],t=-1,n=null,Z(addEventListener),a=l,i.push(a),X()})))}))};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-utils/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var LOCALSTORAGE_COUNTRYCODE_KEY = "xdesign-utils__country-code";
// 是否更新过本地国家码缓存
var hasUpdateLocalCountryCode = false;
// 正在请求状态
var fetchLoading = false;
var processingFetch = function () { };
var instanceFetch = null;
var getRequestUrl = function () {
    if (window.isIntl && window.deployApp === 'designkit') {
        return 'designkit-webapi.designkit.com';
    }
    return window.isIntl ? "www.x-design.com/api" : "webapi.designkit.cn";
};
var fetchRequest = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var defaultCode, res, data, info, code;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                defaultCode = window.isIntl ? "SG" : "CN";
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                fetchLoading = true;
                return [4 /*yield*/, (0,axios/* default */.Z)("https://".concat(getRequestUrl(), "/common/ip_location"), {
                        params: { ts_random_id: esm_browser_v4() },
                        timeout: timeout,
                    })];
            case 2:
                res = _b.sent();
                data = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || {};
                info = Object.values(data)[0] || {};
                code = info === null || info === void 0 ? void 0 : info.nation_code;
                if (code) {
                    hasUpdateLocalCountryCode = true;
                    // 更新缓存
                    window.localStorage.setItem(LOCALSTORAGE_COUNTRYCODE_KEY, code);
                }
                processingFetch(code || defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 3:
                _b.sent();
                processingFetch(defaultCode);
                fetchLoading = false;
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var handleGetCodeProcess = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fetchRequest(timeout || 200);
                return [4 /*yield*/, new Promise(function (resolve) { return (processingFetch = resolve); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * 获取云储存分摊埋点透传值
 * @param timeout ip_location接口超时时间
 * @returns
 */
var getCountryCode = function (timeout) { return __awaiter(void 0, void 0, void 0, function () {
    var country_code, country_code_local, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                country_code_local = (_b = window === null || window === void 0 ? void 0 : window.localStorage) === null || _b === void 0 ? void 0 : _b.getItem(LOCALSTORAGE_COUNTRYCODE_KEY);
                if (!!country_code_local) return [3 /*break*/, 5];
                if (!instanceFetch) return [3 /*break*/, 2];
                return [4 /*yield*/, instanceFetch];
            case 1:
                _a = _c.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, (instanceFetch = handleGetCodeProcess(timeout))];
            case 3:
                _a = _c.sent();
                _c.label = 4;
            case 4:
                // 处理并发情况
                country_code = _a;
                // 成功后释放实例
                instanceFetch = null;
                return [3 /*break*/, 6];
            case 5:
                country_code = country_code_local;
                _c.label = 6;
            case 6:
                // 如果还没请求过接口，异步更新本地缓存
                if (!hasUpdateLocalCountryCode && !fetchLoading) {
                    fetchRequest(3000);
                }
                return [2 /*return*/, country_code];
        }
    });
}); };

/**
 * 获取云储存分摊埋点透传值
 * @param options
 * @returns
 */
var getMTCCClient = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var gid, functionInfo, positionInfo, isToB, virtualId, uid, osType, app_id, isIntl, isTeam, isPcPlatform, mediaType, resMediaType, country_code, appId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                gid = options.gid, functionInfo = options.functionInfo, positionInfo = options.positionInfo, isToB = options.isToB, virtualId = options.virtualId, uid = options.uid, osType = options.osType, app_id = options.app_id, isIntl = options.isIntl, isTeam = options.isTeam, isPcPlatform = options.isPcPlatform, mediaType = options.mediaType, resMediaType = options.resMediaType;
                return [4 /*yield*/, getCountryCode()];
            case 1:
                country_code = _a.sent();
                appId = '';
                if (app_id) {
                    // 业务自定义
                    appId = app_id;
                }
                else if (isPcPlatform) {
                    // pc内嵌下
                    appId = '8045';
                }
                else if (isIntl || window.isIntl) {
                    // designKit 全球化 / 海外 x-design
                    appId = window.deployApp === 'designkit' ? '227' : '2000010';
                }
                else {
                    // web国内
                    appId = '178';
                }
                return [2 /*return*/, btoa(JSON.stringify({
                        app_id: appId,
                        os_type: osType,
                        country_code: country_code,
                        gnum: gid,
                        function: functionInfo,
                        position: positionInfo,
                        media_type: mediaType,
                        res_media_type: resMediaType,
                        ext_info: {
                            biz_type: isTeam ? 'team' : isToB ? 'api' : '',
                            virtual_id: virtualId,
                        },
                        uid: uid || '',
                    }))];
        }
    });
}); };

var num = 0;
var getDemo = function () {
    num++;
    return num;
};

/**
 * 初始化访问两个页面上报代码
 * @param callback
 */
var initViewMoreThan2Pages = function (callback) {
    var pageViewCount = Number(localStorage.getItem("gaPageViewCount"));
    pageViewCount++;
    if (pageViewCount === 3) {
        // 广告转化
        callback("conversion", {
            send_to: "AW-871914325/YIzgCInN5ssZENW24Z8D",
        });
        // ga 事件
        callback("view_more_than_2_pages", {});
    }
    localStorage.setItem("gaPageViewCount", String(pageViewCount));
};
/**
 * 初始化访问超过1分钟页面上报代码
 * @param callback
 */
var initViewMoreThan1Min = function (callback) {
    var currentTotalTime = Number(localStorage.getItem("gaTotalTime")) || 0;
    var timer;
    if (currentTotalTime < 60) {
        var totalTime_1 = 0;
        timer = setInterval(function () {
            if (localStorage.getItem("gaTotalTime") != null) {
                totalTime_1 = Number(localStorage.getItem("gaTotalTime")) || 0;
                totalTime_1++;
                if (totalTime_1 > 60) {
                    clearInterval(timer);
                    return;
                }
                localStorage.setItem("gaTotalTime", String(totalTime_1));
                if (totalTime_1 == 60) {
                    // 广告转化
                    callback("conversion", {
                        send_to: "AW-871914325/mF1GCIbN5ssZENW24Z8D",
                    });
                    //GA4
                    callback("view_more_than_1_min", {});
                }
            }
            else {
                totalTime_1 = 0;
                localStorage.setItem("gaTotalTime", String(totalTime_1));
            }
        }, 1000);
    }
};
/**
 * @description 轮询获取gtag 是否已经动态插入
 * @returns
 */
var checkGtagLoaded = function () {
    var count = 0;
    return new Promise(function (res, rej) {
        // 如果 gtag 未定义，轮询检查,超过1分钟直接暂停
        var interval = setInterval(function () {
            if (window.dataLayer && window.gtag) {
                clearInterval(interval);
                res(true);
            }
            count++;
            // 超过60秒 放弃轮询
            if (count > 30) {
                clearInterval(interval);
                rej({ message: "not gtag" });
            }
        }, 2000); // 每2秒检查一次
    });
};
/**
 * @description 初始化基础分析
 * @param param
 */
var initBasicAnalysis = function (_a) {
    var hasViewMoreThan2Pages = _a.hasViewMoreThan2Pages, hasViewMoreThan1Min = _a.hasViewMoreThan1Min, callback = _a.callback;
    return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, checkGtagLoaded()];
                case 1:
                    _b.sent();
                    hasViewMoreThan2Pages && initViewMoreThan2Pages(callback);
                    hasViewMoreThan1Min && initViewMoreThan1Min(callback);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    console.log(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
};

// 埋点文档 https://dayu.starii-rover.com/requirement/requirement?sso_code=7218504577643970560_1721025604
var DEFAULT_CONFIG = {
    debug_mode: true,
    traffic_type: "internal",
};
/**
 * @description GAEventTracker 类 谷歌自定义事件埋点
 */
var GAEventTracker = /** @class */ (function () {
    function GAEventTracker() {
        this.entrance = null;
        this.isStopGa = false; // 默认收集 ga 自定义事件
        this.env = "pre"; // 默认为pre环境
    }
    /**
     * @description 获取当前埋点入口
     * @returns
     */
    GAEventTracker.prototype.getEntrance = function () {
        return this.entrance;
    };
    /**
     * @description 设置当前埋点入口
     * @param newEntrance
     * @example
     *     比如用户在导航登录按钮点击之后需要设置当前埋点入口为 TopNav
     *     gaEventTracker.setEntrance('TopNav')
     */
    GAEventTracker.prototype.setEntrance = function (newEntrance) {
        this.entrance = newEntrance;
    };
    /**
     * @description 获取是否暂停ga 收集 状态
     * @returns
     */
    GAEventTracker.prototype.getIsStopGa = function () {
        return this.isStopGa;
    };
    /**
     * @description 设置是否暂停ga 收集
     * @param {boolean} bool     是否暂停
     * @example
     *     setStopGa(true)   // 停止收集
     *     setStopGa(false)  // 开始收集
     */
    GAEventTracker.prototype.setStopGa = function (bool) {
        this.isStopGa = bool;
    };
    /**
     * @description 设置配置
     * @param {"pre"|"beta"|"release"}  pre                          环境
     * @param {boolean} [isStopGa = false] isStopGa                  是否暂停ga 收集 默认为false
     * @example
     *     setConfig({env:'pre'}) // 设置环境为pre
     *     setConfig({env:'pre',isStopGa: true}) // 设置环境为pre,暂停ga 自定义事件收集
     */
    GAEventTracker.prototype.setConfig = function (config) {
        var _this = this;
        var env = config.env, _a = config.isStopGa, isStopGa = _a === void 0 ? false : _a, _b = config.hasViewMoreThan1Min, hasViewMoreThan1Min = _b === void 0 ? true : _b, _c = config.hasViewMoreThan2Pages, hasViewMoreThan2Pages = _c === void 0 ? true : _c;
        this.env = env;
        this.isStopGa = isStopGa;
        // 默认添加 网页浏览超过2页面 & 网页浏览超过1分钟 统计
        if (typeof window !== "undefined") {
            initBasicAnalysis({
                hasViewMoreThan2Pages: hasViewMoreThan2Pages,
                hasViewMoreThan1Min: hasViewMoreThan1Min,
                callback: function (eventName, eventParams) {
                    _this.sendGaEvent(eventName, eventParams);
                },
            });
        }
    };
    /**
     * @description 获取当前环境
     * @returns
     */
    GAEventTracker.prototype.getEnv = function () {
        return this.env;
    };
    /**
     * @description 获取GAEventTracker实例
     * @returns
     */
    GAEventTracker.getInstance = function () {
        if (!GAEventTracker.instance) {
            GAEventTracker.instance = new GAEventTracker();
        }
        return GAEventTracker.instance;
    };
    /**
     * @description 发送GA事件
     * @param {string} eventName
     * @param {any} eventParams
     * @example
     *     目前之封装了注册|登录、购买成功的、保存成功的事件（都是基于 sendGaEvent 事件来的），如果其他事件需要发送，可以直接调用sendGaEvent方法
     */
    GAEventTracker.prototype.sendGaEvent = function (eventName, eventParams) {
        var _a;
        if (this.isStopGa) {
            // 暂停事件收集，直接退出
            return;
        }
        // 发送GA事件
        // debug_mode 模式打开可在谷歌分析后台debugview 里查看实时事件
        // traffic_type = internal 区分内部测试数据，beta|pre 环境都是内部测试数据，release 环境是正式数据
        if (window.dataLayer && window.gtag) {
            var params = eventParams;
            if (this.env !== "release") {
                params = __assign(__assign({}, params), DEFAULT_CONFIG);
            }
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "event", eventName, params);
        }
    };
    /**
     * @description 发送登录/注册结果GA事件
     * @param {boolean} isRegister                          是否注册  MeituAccount里的 onLoginSuccess 第二个参数可以区分是否注册
     * @param {string|undefined} [platform='email']         平台（登录方式） MeituAccount里的 onLoginSuccess 第一个参数的platform属性 可以区分平台，
     * @param {string} pageName                             页面名称
     * @param {string|undefined} [entrance]                 入口名称
     * @example
     *     MeituAccount({
     *            ......
     *            onLoginSuccess: (result, isRegister) => {
     *                    //result.platform 是存在undefined 的情况的
     *                    const pageName = 'home'
     *                    const entrance = 'xxxxx' // 入口名称
     *                    gaEventTracker.sendLoginGaTrack(isRegister, result.platform, pageName, entrance)
     *            }
     *            ....
     *    })
     * @see MeituAccount 登录注册接口文档 https://f2er.meitu.com/account/api/account-alipay-mini-program/function/onLoginSuccess
     */
    GAEventTracker.prototype.sendLoginGaTrack = function (isRegister, platform, pageName, entrance) {
        if (platform === void 0) { platform = "email"; }
        // ads转化代码
        if (isRegister) {
            this.sendGaEvent("conversion", {
                send_to: "AW-871914325/fpXBCIPN5ssZENW24Z8D",
            });
        }
        this.sendGaEvent(isRegister ? "register_result" : "login_result", {
            page_name: pageName,
            method: platform,
            entrance: entrance || this.entrance || "topnav",
        });
    };
    /**
     * @description 发送购买结果GA事件
     * @param {OrderTradeProgress[]} tradeProgress        订单交易数据
     * @param {boolean} isVip                             是否是会员
     * @param {string} funcSource                         功能来源
     * @param {string|undefined} [entrance]               入口名称
     * @example
     *    openSubscribePopup({
     *            ......
     *            onTradeFinish(tradeProgress) {
     *                const isVip = true // 假设是会员
     *                const funcSource = 'home' // 假设是首页
     *                const entrance = 'xxxxx' // 入口名称
     *                gaEventTracker.sendPurchaseGaTrack(tradeProgress, isVip, funcSource,entrance)
     *            }
     *            ......
     *    })
     * @see tradeProgress 交易接口文档 https://f2er.meitu.com/subscribe/api/subscribe-core/interface/OrderTradeProgressProduct
     */
    GAEventTracker.prototype.sendPurchaseGaTrack = function (tradeProgress, isVip, funcSource, entrance) {
        var _this = this;
        tradeProgress.forEach(function (v, i) {
            var _a = v.product, productId = _a.productId, moneyUnit = _a.moneyUnit, price = _a.price, isProbation = _a.isProbation, payChannel = v.payChannel, transactionId = v.transactionId;
            var gaData = {
                value: price,
                currency: moneyUnit,
                transaction_id: transactionId,
                user_type: isVip ? 1 : 0,
                item_id: productId,
                payment_type: payChannel,
                is_try: isProbation ? 0 : 1,
                func_source: funcSource,
                entrance: entrance || _this.entrance || "topnav",
            };
            // ads转化代码
            _this.sendGaEvent("conversion", {
                send_to: "AW-871914325/CMpSCIzN5ssZENW24Z8D",
            });
            // ga
            _this.sendGaEvent("purchase", gaData);
        });
    };
    /**
     * @description     发送保存成功GA事件
     * @param {string} from                               来源
     * @param {string} func                               功能名称
     * @example
     *      const from = 'home';// 假设是home, 可以调用 getFrom() 方法获取来源，如果有的话
     *      const func = 'create_now';// 假设是create_now
     *      sendSaveSuccessGaTrack(from, func)
     */
    GAEventTracker.prototype.sendSaveSuccessGaTrack = function (from, func) {
        if (func === void 0) { func = "create_now"; }
        // 获取链接from参数
        this.sendGaEvent("save_success", {
            source: from || "other",
            func: func,
        });
    };
    GAEventTracker.prototype.sendUploadClickGaTrack = function () {
        // 获取链接from参数
        this.sendGaEvent("upload_click", {});
    };
    return GAEventTracker;
}());
var gaEventTracker = GAEventTracker.getInstance();

/**
 * @description 弹窗弹出管理器，目前支持登录和下载 时机时主动弹出订阅弹窗
 */
var PopupManager = /** @class */ (function () {
    // 私有构造函数，防止外部实例化
    function PopupManager() {
        this.maxLoginPopupCount = 1;
        this.maxDownloadPopupCount = 1;
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
        if (typeof window !== "undefined") {
            // 仅在客户端环境中访问 localStorage
            var savedState = localStorage.getItem("popupState");
            if (savedState) {
                this.state = JSON.parse(savedState);
            }
            else {
                this.updateState();
            }
        }
    }
    // 获取单例实例
    PopupManager.getInstance = function () {
        if (!PopupManager.instance) {
            PopupManager.instance = new PopupManager();
        }
        return PopupManager.instance;
    };
    // 设置配置方法
    /**
     * @description 设置配置方法
     * @param config PopupConfig
     * @example
     *
     *      //项目初始化的时候
     *      setConfig({
     *        maxLoginPopupCount: 1, // 最大登录弹窗次数
              maxDownloadPopupCount: 1, // 最大下载弹窗次数
     *      })
     */
    PopupManager.prototype.setConfig = function (config) {
        var maxLoginPopupCount = config.maxLoginPopupCount, maxDownloadPopupCount = config.maxDownloadPopupCount;
        if (maxLoginPopupCount !== undefined) {
            this.maxLoginPopupCount = maxLoginPopupCount;
        }
        if (maxDownloadPopupCount !== undefined) {
            this.maxDownloadPopupCount = maxDownloadPopupCount;
        }
    };
    // 更新并保存状态到 localStorage
    PopupManager.prototype.updateState = function () {
        localStorage.setItem("popupState", JSON.stringify(this.state));
    };
    /**
     * @description 弹出处理方法
     * @param popupType
     * @param callback
     * @example
     *     在需要主动弹出订阅时调用
     *     popupManager.handlePopup("login", () => {
     *        // 弹出订阅窗口 逻辑，比如 (openVipModal 是业务方打开订阅窗口公共方法)
     *        openVipModal({
                entrance: xxxx,
                source: xxxx,
                trackEntrance: xxxxx,
              })
     *     })
     */
    PopupManager.prototype.handlePopup = function (popupType, callback) {
        if (popupType === "login") {
            if (this.state.currentLoginPopupCount < this.maxLoginPopupCount) {
                this.state.currentLoginPopupCount++;
                this.updateState();
                callback();
            }
        }
        else if (popupType === "download") {
            if (this.state.currentDownloadPopupCount < this.maxDownloadPopupCount) {
                this.state.currentDownloadPopupCount++;
                this.updateState();
                callback();
            }
        }
    };
    /**
     * @description 退出登录清空数据
     * @example
     *      //退出登录时调用
     *      popupManager.logout()
     */
    PopupManager.prototype.logout = function () {
        if (typeof window !== "undefined") {
            localStorage.removeItem("popupState");
        }
        this.state = {
            currentLoginPopupCount: 0,
            currentDownloadPopupCount: 0,
        };
    };
    return PopupManager;
}());
var popupManager = PopupManager.getInstance();

var checkDebugConfig = function () {
    var localConfig = window.localStorage.getItem("performanceMonitor");
    if (!localConfig) {
        return false;
    }
    try {
        var debug = JSON.parse(localConfig).debug;
        return !!debug;
    }
    catch (e) {
        return false;
    }
};
var prettyLog = function (title, text, rating) {
    var color = "#00a67d";
    if (rating === "needs-improvement") {
        color = "#ffc92e";
    }
    if (rating === "poor") {
        color = "#f22c3d";
    }
    console.log("%c ".concat(title, " %c ").concat(text, "ms %c"), "background:".concat(color, ";border:1px solid ").concat(color, "; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;"), "border:1px solid ".concat(color, "; padding: 1px; border-radius: 0 2px 2px 0; color: ").concat(color, ";"), "background:transparent");
};
var log = function (name, data) {
    if (!checkDebugConfig()) {
        return;
    }
    var arr = __spreadArray([], (0,lodash.map)(data, function (value, key) { return ({ key: key, value: value }); }), true);
    console.table(arr, ["key", "value"]);
    prettyLog(name, data.value || data.duration, data.rating);
};
/**
 * 获取当前网络信息
 * @returns 网络信息对象
 */
var getNetworkInfo = function () {
    var networkInfo = {};
    // 获取连接类型信息
    if (navigator.connection) {
        var connection = navigator.connection;
        networkInfo.effectiveType = connection.effectiveType || "unknown"; // 有效网络类型：4g、3g、2g、slow-2g
        networkInfo.downlink = connection.downlink || 0; // 下行速度(Mbps)
        networkInfo.rtt = connection.rtt || 0; // 往返时间(ms)
        networkInfo.saveData = connection.saveData || false; // 是否启用省流量模式
        networkInfo.type = connection.type || "unknown"; // 网络类型
    }
    // 获取在线状态
    networkInfo.online = navigator.onLine;
    return networkInfo;
};
/**
 * @description 上报埋点
 * @param data
 */
var handlerWebVitalsTrack = function (data) {
    var metric = data.metric, name = data.name, statTrack = data.statTrack, domInfo = data.domInfo;
    log(name, metric);
    statTrack("tech_metric_web_basic", {
        metric_type: name,
        duration: metric.value,
        score: metric.rating,
        //源数据
        metricData: metric,
        //是否登录, 首页和工作台访问需要区分是否登录
        isLogin: !!window.localStorage.getItem("uid"),
        // 网络情况数据
        networkInfo: getNetworkInfo(),
        // 元素信息
        domInfo: domInfo,
    });
};
/**
 *
 * @param url 获取url参数长度
 * @returns
 */
var getUrlParamsLength = function (url) {
    var queryIndex = url.indexOf("?");
    if (queryIndex === -1)
        return 0; // 没有参数
    return url.length - queryIndex - 1;
};
/**
 * 获取请求参数数据
 * @param response Axios响应对象
 * @returns POST请求返回data数据，GET请求返回params数据
 */
var getUrlParamsData = function (config) {
    var method = config.method;
    if ((method === null || method === void 0 ? void 0 : method.toUpperCase()) === "POST") {
        return config.data;
    }
    else {
        return config.params;
    }
};
/**
 * 获取请求 status 对应的 code (埋点用), 2xx 都算成功
 * @param status 状态码
 * @returns number 1: 成功，0: 失败
 */
var getRequestSuccess = function (status) {
    return status >= 200 && status < 300 ? 1 : 0;
};
/**
 * @description 获取DOM元素的className
 * @param metric
 * @returns
 */
var getDomInfo = function (metric) {
    var className = "";
    var nodeName = "";
    var innerText = "";
    try {
        var entriesData = metric.entries;
        if (entriesData && entriesData[0]) {
            var target = entriesData[0].target;
            if (target) {
                if (target.className) {
                    className = target.className;
                }
                if (target.nodeName) {
                    nodeName = target.nodeName;
                }
                if (target.innerText) {
                    innerText = target.innerText;
                }
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return {
        className: className,
        nodeName: nodeName,
        innerText: innerText,
    };
};

/**
 * @description 性能监控与埋点工具箱
 * 提供Web性能监控和各类操作耗时统计的能力
 * @link 埋点文档: https://dayu.starii-rover.com/requirement/requirement?id=3096&appId=227&platformAgg=WEB&fullScreen=true
 * @link 需求文档：https://cf.meitu.com/confluence/pages/viewpage.action?pageId=549555498
 */
var performanceMonitor = {
    utils: {
        getUrlParamsData: getUrlParamsData,
        getUrlParamsLength: getUrlParamsLength,
    },
    setConfig: function (config) {
        window.localStorage.setItem("performanceMonitor", JSON.stringify(config));
    },
    /**
     * @description 监控并上报Web Vitals核心性能指标
     * 包括：TTFB, LCP, FCP, INP, CLS
     * @param statTrack 数据上报函数
     * @param sentry Sentry实例 （预留）
     */
    reportWebVitals: function (statTrack, sentry) {
        /**
         * @description 测量 TTFB (Time to First Byte)
         * 测量从请求开始到收到第一个字节的时间
         * 反映服务器响应速度
         * @example 如果 value 是 200，表示用了 200ms 接收到首字节
         */
        Q(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "TTFB", statTrack: statTrack });
        });
        /**
         * @description  LCP (Largest Contentful Paint)
         * 测量页面最大内容元素的渲染时间
         * 反映页面加载性能
         * @example 如果 value 是 2000，表示最大内容元素渲染了 2000ms
         */
        G(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "LCP", statTrack: statTrack });
        }, { reportAllChanges: true });
        /**
         * @description  FCP (First Contentful Paint)
         * 测量首次内容绘制时间
         * 反映用户首次看到实际内容的时间
         * @example 如果 value 是 1000，表示用户在 1 秒后看到第一个内容
         */
        S(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "FCP", statTrack: statTrack });
        });
        /**
         * @description  INP (Interaction to Next Paint)
         * 测量交互到下一次绘制的时间
         * 反映页面交互响应性能
         * @example 如果 value 是 200，表示用户交互后200ms内完成了视觉更新
         */
        j(function (metric) {
            handlerWebVitalsTrack({
                metric: metric,
                name: "INP",
                statTrack: statTrack,
                domInfo: getDomInfo(metric),
            });
        }, { reportAllChanges: true });
        /**
         * @description  CLS (Cumulative Layout Shift)
         * 测量累积布局偏移
         * 反映页面视觉稳定性
         * @example 如果 value 是 0.1，表示页面的视觉稳定性较好，得分范围通常在 0-1 之间，越接近 0 越好
         */
        w(function (metric) {
            handlerWebVitalsTrack({ metric: metric, name: "CLS", statTrack: statTrack });
        }, { reportAllChanges: true });
    },
    /**
     * @description 获取操作开始时间戳
     * 用于记录任意操作的开始时间，如API请求、资源下载、计算过程等
     * @example
     * const startTime = performanceMonitor.getStartTime();
     * @returns {number} 当前时间戳（performance.now()）
     */
    getStartTime: function () {
        return performance.now();
    },
    /**
     * @description 上报操作耗时[通用]
     * 计算并上报任意操作的耗时数据，如API请求、资源下载、计算过程等
     * @param data.startTime 操作开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，附加数据
     * @param data.sentry Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @example
     * // API请求耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "api_request",
     *   trackData: { url: "/api/users", method: "GET" }
     * });
     *
     * // 资源加载耗时上报
     * performanceMonitor.reportTiming({
     *   startTime,
     *   statTrack,
     *   eventName: "resource_load",
     *   trackData: { type: "image", url: "https://example.com/image.png" }
     * });
     */
    reportTiming: function (data, callback) {
        var startTime = data.startTime, statTrack = data.statTrack, _a = data.eventName, eventName = _a === void 0 ? "general_timing" : _a, _b = data.trackData, trackData = _b === void 0 ? {} : _b;
        var duration = performance.now() - startTime;
        log(eventName, __assign(__assign({}, trackData), { duration: duration }));
        statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
        callback === null || callback === void 0 ? void 0 : callback();
    },
    /**
     * @description 上报Axios请求耗时
     * 计算并上报 Axios 请求的耗时数据
     * @param data.statTrack 数据上报函数
     * @param data.config Axios请求配置
     * @param data.status 响应状态码
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     * @example
     * @example
     * // 假设在Axios请求拦截器中记录了请求开始时间
     * axios.interceptors.request.use(config => {
     *   config.startTime = performance.now();  // 记录请求开始时间
     *   return config;
     * });
     *
     * // 在响应拦截器中计算并上报耗时
     * axios.interceptors.response.use(response => {
     *   const { startTime, statTrack } = response.config;   // 从请求配置中获取开始时间
     *   performanceMonitor.reportRequestTiming({
     *     statTrack,
     *     status: response.status,  // 响应状态码
     *     config: response.config  // 完整的请求配置
     *   });
     *   return response;  // 继续处理响应
     * })
     */
    reportRequestTiming: function (data, callback) {
        var config = data.config, statTrack = data.statTrack, status = data.status;
        if (!config)
            return;
        var startTime = config.startTime, method = config.method, url = config.url;
        if (!startTime || !url)
            return;
        this.reportTiming({
            startTime: startTime,
            statTrack: statTrack,
            eventName: "tech_metric_api_request_result",
            trackData: {
                is_success: status !== undefined ? getRequestSuccess(status) : 0,
                api_endpoint: url,
                request_method: method ? method.toUpperCase() : undefined,
                request_params: getUrlParamsData(config),
                param_length: getUrlParamsLength(url),
            },
        }, callback);
    },
    /**
     * @description 监控DOM元素渲染时间
     * 使用MutationObserver监听特定DOM元素的变化，计算并上报渲染耗时
     * @param data.startTime 可选，开始时间戳
     * @param data.statTrack 数据上报函数
     * @param data.element 要监控的DOM元素引用（例如React的ref.current）
     * @param data.eventName 埋点事件名称
     * @param data.trackData 可选，额外上报数据
     * @param data.config 可选，MutationObserver配置
     * @param data.timeout 可选，监控超时时间(ms)，默认10000ms
     * @param data.waitForImages 可选，是否要等待src属性的图片加载完成，默认true [大部分都是图片列表，如果只是简单监听dom渲染可以直接设置为false]
     * @param data.sentry 可选 Sentry实例 （预留）
     * @param callback 可选，回调函数，用于处理补充逻辑
     *
     * @returns MutationObserver实例，可用于手动断开观察
     * @example
     * // 在React组件中使用
     * const contentRef = useRef(null);
     * useEffect(() => {
     *   // startTime 可选，reportRenderTime 方法里有做自动获取 startTime 处理
     *   const startTime = performanceMonitor.getStartTime();
     *   // 数据加载完成后监控DOM渲染
     *   performanceMonitor.reportRenderTime({
     *     startTime,
     *     element: contentRef.current,
     *     statTrack,
     *     eventName: "list_render",
     *     trackData: { itemsCount: items.length }
     *   });
     * }, [items]);
     */
    reportRenderTime: function (data, callback) {
        var _a = data.startTime, startTime = _a === void 0 ? this.getStartTime() : _a, statTrack = data.statTrack, element = data.element, eventName = data.eventName, _b = data.trackData, trackData = _b === void 0 ? {} : _b, _c = data.config, config = _c === void 0 ? {
            childList: true,
            subtree: true,
            attributes: true,
        } : _c, _d = data.timeout, timeout = _d === void 0 ? 10000 : _d, _e = data.waitForImages, waitForImages = _e === void 0 ? true : _e;
        if (!element) {
            console.warn("reportRenderTime：The element is null.");
            return null;
        }
        // 防止重复上报
        var hasReported = false;
        // 创建MutationObserver实例
        var observer = new MutationObserver(function (mutations) {
            if (hasReported)
                return;
            // 确保DOM渲染后再检查图片
            requestAnimationFrame(function () {
                if (waitForImages) {
                    // 获取容器内所有图片
                    var images_1 = element.querySelectorAll("img");
                    if (images_1.length === 0) {
                        // 没有图片，直接上报DOM渲染时间
                        reportTiming();
                        return;
                    }
                    // 检查所有图片是否已加载
                    var loadedCount_1 = 0;
                    var imageArray = Array.from(images_1);
                    // 已加载的图片计数
                    imageArray.forEach(function (img) {
                        if (img.complete) {
                            loadedCount_1++;
                        }
                        else {
                            // 为未加载完的图片添加事件监听
                            img.addEventListener("load", function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                            // 处理图片加载失败情况
                            img.addEventListener("error", function () {
                                if (hasReported)
                                    return; // 先检查是否已上报
                                loadedCount_1++;
                                if (loadedCount_1 === images_1.length) {
                                    reportTiming();
                                }
                            });
                        }
                    });
                    // 如果所有图片已经加载完成，直接上报
                    if (loadedCount_1 === images_1.length && !hasReported) {
                        // 确保这里也检查hasReported
                        reportTiming();
                    }
                }
                else {
                    // 不等待图片加载，仅监控DOM变化
                    reportTiming();
                }
            });
        });
        // 上报时间的函数
        function reportTiming() {
            if (hasReported)
                return; // 即使被多次调用也不会重复上报
            var duration = performance.now() - startTime;
            log(eventName, __assign(__assign({}, trackData), { duration: duration }));
            statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
            hasReported = true;
            observer.disconnect();
            callback === null || callback === void 0 ? void 0 : callback();
        }
        observer.observe(element, config);
        // 设置超时，防止无限等待
        setTimeout(function () {
            if (!hasReported) {
                var duration = -1;
                statTrack(eventName, __assign(__assign({}, trackData), { duration: duration }));
                observer.disconnect();
                callback === null || callback === void 0 ? void 0 : callback({ timeout: true });
            }
        }, timeout);
    },
};




/***/ })

}]);